import React from 'react';
import Grid from '@mui/material/Grid2';

function DetailSection({ className = '', icon, title, children }) {
  return (
    <div className={className}>
      <div className="title">{icon && <span className={icon} />}<span>{title}</span></div>
      <div>{children}</div>
    </div>
  );
}

export function ReminderDetailContent({
  canManage, canRemove, categoryId, categoryLabel, completedAtLabel, creatorLabel,
  dateLine, dateTimeLabel, hacLabels, isCompleted, isCompleting, isSystemTask, onClose, onComplete,
  onEdit, onMemberClick, onRemove, ownerLabel, task, t,
}) {
  return (
    <>
      <button className="close" type="button" onClick={onClose}><span className="icon-close" /></button>
      <h2><span className={`cat-${categoryId}`} />{task?.title || ''}</h2>

      <DetailSection className="date" icon="icon-clock" title={t('calendar-date')}>
        <div>{dateLine}</div>{dateTimeLabel && <div>{dateTimeLabel}</div>}
      </DetailSection>

      <Grid container spacing={2} className="separator">
        <Grid size={{ xs: 12, md: 6 }}><DetailSection className="creator" icon="icon-user" title={t('calendar-created-by')}>{creatorLabel && <span className="chip">{creatorLabel}</span>}</DetailSection></Grid>
        <Grid size={{ xs: 12, md: 6 }}><DetailSection className="owner" icon="icon-user" title={t('calendar-owner')}>{ownerLabel && <span className="chip">{ownerLabel}</span>}</DetailSection></Grid>
      </Grid>

      <DetailSection className="hacs" icon="icon-user" title={t('calendar-tag-members')}>
        {hacLabels.length ? hacLabels.map((member) => (
          <button type="button" className="chip clickable" key={member.id} onClick={() => onMemberClick(member)}>{member.label}</button>
        )) : <p className="note">{t('calendar-no-tagged-members')}</p>}
      </DetailSection>

      <Grid container spacing={2} className="separator">
        <Grid size={{ xs: 12, md: 6 }}>
          <DetailSection className="category" title={t('calendar-reminder-category')}>
            <div className="category-value"><span className={`cat-${categoryId}`} />{categoryLabel}</div>
          </DetailSection>
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <DetailSection className="completion-status" title={t('calendar-completion-status')}>
            {isCompleted ? t('calendar-status-completed') : t('calendar-status-current')}
          </DetailSection>
        </Grid>
      </Grid>

      <DetailSection className="desc" icon="icon-note" title={t('calendar-reminder-description')}>
        {task?.description || <p className="note">{t('calendar-no-description')}</p>}
      </DetailSection>

      <div className="actions">
        {canRemove && <button className="btn secondary" type="button" onClick={onRemove}>{t('common-remove')}</button>}
        {!isCompleted && canManage && <button className="btn secondary" type="button" onClick={onEdit}>{t('common-edit')}</button>}
        {!isCompleted && canManage && !isSystemTask && (
          <button className="btn primary" type="button" onClick={onComplete} disabled={isCompleting}>{t('calendar-mark-completed')}</button>
        )}
      </div>

      {isCompleted && (
        <div className="completion-details">
          <p className="note txt-right">{t('calendar-completed-by')}: {task?.complete_by_name || '—'}</p>
          <p className="note txt-right">{t('calendar-completed-at')}: {completedAtLabel || '—'}</p>
        </div>
      )}
    </>
  );
}
